import { useCallback } from "react";
import { useForm } from "react-hook-form";
import { useTranslation } from "react-i18next";
import { MESSAGES } from "~/resources/Message";
import { FormConfigFile, FormScriptResponse } from "~/models/Commons ";
import { useAddConfigFileMutation } from "~/services/script";

export const useFormConfigFile = (
  editedItem: FormScriptResponse | null,
  onCloseModal: () => void,
  refetch: () => void,
  deploymentScriptId: string,
  onSuccess?: (title: string, message: string, response: any) => void,
  onError?: (title: string, message: string) => void,
) => {
  const { t } = useTranslation();
  const [addConfigFile, { isLoading, isError }] = useAddConfigFileMutation();

  const {
    formState: { errors },
    handleSubmit,
    control,
    setValue,
    setError,
    clearErrors,
    watch,
  } = useForm<FormConfigFile>({
    mode: "onChange",
    reValidateMode: "onChange",
    defaultValues: {
      configFiles: null,
    },
  });

  const currentConfigFiles = watch("configFiles");

  // Handler for config files drop
  const onConfigDrop = useCallback(
    (acceptedFiles: File[]) => {
      const file = acceptedFiles?.[0] || null;

      setValue("configFiles", file);
      if (file) {
        clearErrors("configFiles");
      } else {
        setError("configFiles", {
          type: "manual",
          message: t("SelectValidFile"),
        });
      }
    },
    [setValue, clearErrors, setError],
  );
 const handleError = (error: any) => {
    onError?.(
      t("Error"),
      error?.data?.message,
    );
  };
  // Form submission handler
  const submitForm = useCallback(
    async (data: FormConfigFile) => {
      // prevent double submit
      if (isLoading) return;
      if (!data.configFiles) {
        setError("configFiles", {
          type: "manual",
          message: MESSAGES.MessageUploadScript,
        });
        return;
      }

      try {
        const payload = {
          data,
          deploymentScriptId: deploymentScriptId || "",
        };
        const response = await addConfigFile(payload).unwrap();
        onSuccess?.(
          t("MessageOperationCompletedSuceesuflly"),
          response?.message || "",
          response,
        );
        onCloseModal();
      } catch (error: any) {
          onError?.(
        `(${error?.data?.status})`,
        error?.data?.detail,
      );
        onCloseModal();
          handleError(error);
      }
    },
    [addConfigFile, editedItem, onCloseModal, refetch, setError],
  );

  return {
    handleSubmit,
    submitForm,
    control,
    errors,
    currentConfigFiles,
    onConfigDrop,
    isLoading,
    isError,
    onSuccess,
    onError,
  };
};
